import domReady from '@wordpress/dom-ready';
import manifest from '../manifest.json';
import iconManifest from './../../../components/icon/manifest.json';

domReady(async () => {
	const { icons } = iconManifest;

	const { blockJsClass, blockJsInnerElementsClass, blockJsDisplayInlineClass, blockJsShowIconsClass } = manifest;

	const blockContainerElements = document.querySelectorAll(`.${blockJsClass}`);
	const innerElementsSelector = `.${blockJsInnerElementsClass}`;
	const displayInlineClass = `${blockJsDisplayInlineClass}`;
	const showIconsClass = `${blockJsShowIconsClass}`;

	if (!blockContainerElements.length) {
		return;
	}

	const { TableOfContents } = await import('./table-of-contents');

	[...blockContainerElements].forEach((element) => {
		const toc = new TableOfContents({
			element,
			icons,
			innerElementsSelector,
			displayInlineClass,
			showIconsClass,
		});

		toc.init();
	});
});
